import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Grid from '@material-ui/core/Grid';

import Header from 'components/Header/Header';
import TreeIndex from 'components/TreeIndex/TreeIndex';
import IndexContent from 'components/IndexContent/IndexContent';
import LocalStorage from 'utils/LocalStorage';

import './HelpLayout.css';

declare var HELP_DATA_ES;
declare var HELP_DATA_EN;

class HelpLayout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: LocalStorage.getString('language') === 'en' ? HELP_DATA_EN[0] : HELP_DATA_ES[0],
      data: LocalStorage.getString('language') === 'en' ? HELP_DATA_EN : HELP_DATA_ES,
    };
  }

  changeSelected = (newSelected) => {
    this.setState({ selected: newSelected });
  }

  render() {
    const { selected } = this.state;
    return (
      <div className='content-wrapper'>
        <Header />
        <section className='layout-wrapper'>
          <Grid container>
            <Grid item className='help-menu' xs={12} sm={6} md={5} lg={3}>
              <TreeIndex data={this.state.data} changeSelected={this.changeSelected} />
            </Grid>
            <Grid item className='help-content' xs={12} sm={6} md={7} lg={9}>
              <IndexContent data={selected} />
            </Grid>
          </Grid>
        </section>
      </div>
    );
  }
}

export default translate()(HelpLayout);
